<template>
<div class="LeaderList">
    <div class="filters">
        <div class="add">
            <el-button type="warning" @click="handleRecommend">推荐佣金</el-button>
            <el-button type="success" @click="handleExport">导出团长</el-button>
            <el-button type="primary" @click="handleInvate">邀请团长</el-button>
            <span class="total">{{headercount}}/{{allinviteheadercount}}</span>
            <el-button type="text" @click="handleService">扩充团长数量 ></el-button>
        </div>
        <div class="search">
            <el-input v-model="param.key" placeholder="请输入团长昵称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-tabs v-model="param.status" @tab-click="handleClick">
            <el-tab-pane label="已审核" name="1">
                <div class="filters">
                    <div class="add">
                        <el-button type="primary" @click="handleSetings"> 批量设置 </el-button>
                    </div>
                    <div class="search">
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%" ref="multipleTable1"
                          @select="handleSelectionChange" @select-all="handleAllSelectionChange"  @row-click="handleRowChange">
                    <el-table-column type="selection" width="50px"></el-table-column>
                    <el-table-column prop="subject" label="团长名称" min-width="250px" class-name="title">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <img class="img" v-lazy="scope.row.headerlogourl" :alt="scope.row.headername" preview="LeaderList">
                                <span>{{scope.row.headername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="linkman" label="联系人" class-name="center"></el-table-column>
                    <el-table-column prop="linktel" label="联系电话" class-name="center" min-width="120px"></el-table-column>
                    <el-table-column prop="fanscount" label="粉丝数" class-name="center"></el-table-column>
                    <el-table-column prop="recommendheadercount" label="推荐数量" class-name="center"></el-table-column>
                    <el-table-column prop="brokeragerateheader" label="团长佣金" class-name="center">
                        <template slot-scope="scope">{{scope.row.brokeragerateheader.toFixed(2)}}%</template>
                    </el-table-column>
                    <el-table-column prop="brokerageraterecommend" label="推荐佣金" class-name="center">
                        <template slot-scope="scope">{{scope.row.brokerageraterecommend.toFixed(2)}}%</template>
                    </el-table-column>
                    <el-table-column prop="applytime" label="绑定时间" class-name="center"  min-width="120px"></el-table-column>
                    <el-table-column prop="recommendhostname" label="推荐团长" class-name="center"></el-table-column>
                    <el-table-column label="操作" min-width="210px" label-class-name="tr">
                        <template slot-scope="scope">
                            <div class="tr">
                                <span class="separator-btn">
                                    <el-button @click.stop="handleRecommendView(scope.row)" type="text" size="small">推荐明细</el-button>
                                </span>
                                <span class="separator-btn">
                                    <el-button @click.stop="handleSetCommission(scope.row)" type="text" size="small">设置佣金</el-button>
                                </span>
                                <span class="separator-btn">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <el-button type="text" size="small" @click.stop>更多</el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="handleShare(scope.row)">分享</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleTotal(scope.row)">统计</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleDel(scope.row)">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" @getList="_getList" ref="page"></page>
            </el-tab-pane>
            <el-tab-pane :label="'待审核( '+tableAuditedtotal+' )'" name="0">
                <div class="filters">
                    <div class="add">
                        <el-button type="primary" @click="handleAuths"> 批量审核 </el-button>
                    </div>
                    <div class="search">
                    </div>
                </div>
                <el-table :data="tableAuditedData" style="width: 100%" ref="multipleTable0"
                          @select="handleSelectionChange" @select-all="handleAllSelectionChange"  @row-click="handleRowChange">
                    <el-table-column type="selection" width="50px"></el-table-column>
                    <el-table-column prop="subject" label="团长名称" min-width="250px" class-name="title">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <img class="img" v-lazy="scope.row.headerlogourl" :alt="scope.row.headername" preview="LeaderList">
                                <span>{{scope.row.headername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="linkman" label="联系人" class-name="center"></el-table-column>
                    <el-table-column prop="linktel" label="联系电话" class-name="center"></el-table-column>
                    <el-table-column prop="applytime" label="绑定时间" class-name="center"  min-width="120px"></el-table-column>
                    <el-table-column prop="recommendhostname" label="推荐团长" class-name="center"></el-table-column>
                    <el-table-column label="操作" width="180px" label-class-name="tr">
                        <template slot-scope="scope">
                            <div class="tr">
                        <span class="separator-btn">
                            <el-button @click.stop="handleAuth(scope.row)" type="text" size="small">审核</el-button>
                        </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="_getList2" :current-page.sync="tableAuditedPage.page" :page-size="tableAuditedPage.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="tableAuditedtotal">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
    <invateDialog ref="invateDialog" @openLinkDialog="_openLinkDialog"></invateDialog>
    <serviceDialog ref="serviceDialog"></serviceDialog>
    <commissionsDialog ref="commissionsDialog" @getList="_getList"></commissionsDialog>
    <commissionDialog ref="commissionDialog" @getList="_getList"></commissionDialog>
    <authDialog ref="authDialog" @getList="refresh"></authDialog>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
    <recommendDialog ref="recommendDialog"></recommendDialog>
    <authsDialog ref="authsDialog"  @getList="refresh"></authsDialog>
</div>
</template>

<script>
import {getHostHeaderListByBrand, uploadDeleteHeaderinfo, getHostHeaderListByBrandExport} from 'api/brandBusiness'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import InvateDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateDialog.vue'
import ServiceDialog from 'views/brandBusiness/leaderMgt/myLeader/components/serviceDialog.vue'
import CommissionsDialog from 'views/brandBusiness/leaderMgt/myLeader/components/commissionsDialog.vue'
import CommissionDialog from 'views/brandBusiness/leaderMgt/myLeader/components/commissionDialog.vue'
import AuthDialog from 'views/brandBusiness/leaderMgt/myLeader/components/authDialog.vue'
import RecommendDialog from 'views/brandBusiness/leaderMgt/myLeader/components/recommendDialog.vue'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
import AuthsDialog from 'views/brandBusiness/leaderMgt/myLeader/components/authsDialog.vue'
import {initPage} from 'common/js/mixin'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'LeaderList',
    mixins: [initPage],
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            power: [],
            param: {
                hostroletype: '',
                key: '',
                status: '1'
            },
            tableData: [],
            tableAuditedData: [],
            total: 0,
            tableAuditedtotal: 0,
            tableAuditedPage: {
                page: 1,
                pageSize: 10
            },
            activeName: '1',
            headercount: '',
            allinviteheadercount: '',
            isAuth: false,
            selectedId1: [],
            selectedId0: []
        }
    },
    mounted() {
        this._getList()
        this._getList2()
    },
    methods: {
        handleAuths() {
            if (!this.selectedId0.length) {
                this.$message.error('请选择需要审核的团长')
                return false
            }
            let item = {
                headerinnerid: [],
                headerrate: '',
                hostroletype: 3,
                recommendrate: ''
            }
            this.selectedId0.forEach(obj => {
                item.headerinnerid.push(obj.headerinnerid)
            })
            item.headerinnerid = item.headerinnerid.join(',')
            this.$refs.authsDialog.openDialog(item)
        },
        handleSetings() {
            if (!this.selectedId1.length) {
                this.$message.error('请选择需要设置的团长')
                return false
            }
            let item = {
                headerinnerid: [],
                headerrate: '',
                hostroletype: 3,
                recommendrate: ''
            }
            this.selectedId1.forEach(obj => {
                item.headerinnerid.push(obj.headerinnerid)
            })
            item.headerinnerid = item.headerinnerid.join(',')
            this.$refs.commissionDialog.openDialog(item, 2)
        },
        handleSelectionChange(selection, row) {
            if (this.activeName == 1) {
                this.selectedId1 = selection
            } else {
                this.selectedId0 = selection
            }
        },
        handleAllSelectionChange(selection) {
            this.handleSelectionChange(selection)
        },
        handleRowChange(row, column, event) {
            let flag = false
            if (this.activeName == 1) {
                this.selectedId1.forEach((obj, i) => {
                    if (row.headerinnerid == obj.headerinnerid) {
                        this.$refs.multipleTable1.toggleRowSelection(row, false)
                        this.selectedId1.splice(i, 1)
                        flag = true
                    }
                })
                if (!flag) {
                    this.$refs.multipleTable1.toggleRowSelection(row)
                    this.selectedId1.push(row)
                }
            } else {
                this.selectedId0.forEach((obj, i) => {
                    if (row.headerinnerid == obj.headerinnerid) {
                        this.$refs.multipleTable0.toggleRowSelection(row, false)
                        this.selectedId0.splice(i, 1)
                        flag = true
                    }
                })
                if (!flag) {
                    this.$refs.multipleTable0.toggleRowSelection(row)
                    this.selectedId0.push(row)
                }
            }
        },
        _openLinkDialog(inviteurlurl) {
            this.$refs.invateLinkDialog.openDialog(inviteurlurl)
        },
        refresh() {
            this.isAuth = true
            this._getList2()
        },
        handleExport() {
            this.setLoading(true)
            getHostHeaderListByBrandExport({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '团长' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleRecommendView(row) {
            this.$refs.recommendDialog.openDialog(row)
        },
        handleShare(row) {
            this.$refs.invateLinkDialog.openDialog(row.shareurl, '分享活动')
        },
        handleService() {
            this.$refs.serviceDialog.openDialog()
        },
        handleAuth(row) {
            this.$refs.authDialog.openDialog(row)
        },
        handleClick() {
            this.activeName = this.param.status
            if (this.param.status == '0' && !this.tableAuditedtotal) {
                this._getList2()
            }
            if (this.isAuth) {
                this._getList()
                this.isAuth = false
            }
        },
        handleRecommend() {
            this.$refs.commissionsDialog.openDialog()
        },
        handleInvate() {
            this.$refs.invateDialog.openDialog()
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleSetCommission(row) {
            this.$refs.commissionDialog.openDialog(row)
        },
        handleTotal(row) {
            this.$router.push({name: 'BBLeaderTotal', query: {headerinnerid: row.headerinnerid}})
        },
        handleDel(row) {
            this.$confirm('确认删除该团长', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row)
            })
        },
        _del(row) {
            this.setLoading(true)
            uploadDeleteHeaderinfo({
                data: Object.assign({}, {headerinnerid: row.headerinnerid}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this. selectedId1 = []
            let param = this._.cloneDeep(this.param)
            param.status = '1'
            this.setLoading(true)
            getHostHeaderListByBrand({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page == 1) {
                        this.headercount = data.data.headercount
                        this.allinviteheadercount = data.data.allinviteheadercount
                    }
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList2() {
            this. selectedId0 = []
            let param = this._.cloneDeep(this.param)
            param.status = '0'
            this.setLoading(true)
            getHostHeaderListByBrand({
                data: Object.assign({}, param, this.tableAuditedPage),
                success: data => {
                    if (this.tableAuditedPage.page > 1 && this.tableAuditedPage.page > data.data.pageinfo.pageCount) {
                        this.tableAuditedPage.page = data.data.pageinfo.pageCount
                        this._getList2()
                    } else {
                        this.tableAuditedData = data.data.content
                        this.tableAuditedtotal = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'user', 'params',])
    },
    components: {
        Page, InvateDialog, ServiceDialog, CommissionsDialog, CommissionDialog, AuthDialog, InvateLinkDialog, RecommendDialog, AuthsDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.LeaderList {
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
    .filters{
        .total{
            margin: 0 50px 0 20px;
        }
    }
    .btn-operate-list .filters .el-button{
        min-width: 96px !important;
    }
}
</style>
